import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/ticket-action';
import TableHeads from '../../hooks/component/sTicket/TableHeads';

import heads from './staticData'; // No necesitas usar llaves aquí
import { useGetTickets } from '../../hooks/services/sTicket/useOfTicket';
import TableItems from './TableItems';
import { Card, Col, Row } from 'react-bootstrap';
import SidePanelAdd from './SidePanelAdd';
import SidePanelEdit from './SidePanelEdit';
import SidePanelAddAnswer from './SidePanelAddAnswer';
import TicketAnswer from './TicketAnswer';
import ReadForm from './ReadForm';
import SidePanelDocument from './SidePanelDocument';
import { useTranslation } from 'react-i18next';

const MainSection = ({ tableItems, actionsConnect }) => {
  const { t } = useTranslation();

  const [tableHeads, setTableHeads] = useState([]);
  const [tickets, setTickets] = useState(null);
  const [hasRefreshTickets, setHasRefreshTickets] = useState(true);
  const [firstLoaded, setFirstLoaded] = useState(false);

  const [isPanelConfigureAddOpen, setIsPanelConfigureAddOpen] = useState(false);
  const [isPanelConfigureEditOpen, setIsPanelConfigureEditOpen] = useState(false);
  const [isPanelConfigureAddAnswerOpen, setIsPanelConfigureAddAnswerOpen] = useState(false);
  const [isPanelDocumentOpen, setIsPanelDocumentOpen] = useState(false);

  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const [selectedTicketAnswerId, setSelectedTicketAnswerId] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState(null);
  const [hasSortBy, setHasSortBy] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useGetTickets(tickets, setTickets)

  useEffect(() => {
    setTableHeads(heads);
    if (tickets && !firstLoaded) {
      actionsConnect.setTickets(tickets);
      setFirstLoaded(true);
    }
    if (hasRefreshTickets && tickets && firstLoaded && !hasSortBy) {
      setHasRefreshTickets(false);
      setTickets(tableItems);
      setHasRefreshTickets(true);
    } 
    if(hasSortBy)   
    {
      setHasSortBy(false);
    }

  }, [actionsConnect, tickets, tableItems, firstLoaded, hasRefreshTickets]);


  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleSort = (column) => {
    setHasSortBy(true);
    if (sortBy === column) {
      setTickets([...tickets].reverse());
    } else {
      setTickets([...tickets].sort((a, b) => {
        if (typeof a[column] === 'number' && typeof b[column] === 'number') {
          return a[column] - b[column];
        } else {
          return String(a[column]).localeCompare(String(b[column]));
        }
      }));
      setSortBy(column);
    }
    
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(parseInt(event.target.value));
    setCurrentPage(1);
  };

  const onOpenConfigureAddPanel = (container) => {
    setIsPanelConfigureAddOpen(true);
    setSelectedTicketId(null);
    setSelectedTicketAnswerId(null);
  };

  const [initialData, setInitialData] = useState({
    id: -1,
    subject: '',
    category: 'Billing',
    assignee: 'Erwin',
    priority: 'Normal',
    answers_number: 0,
    has_docs: false
  });




  const handleEditFormOpen = (tableItem) => {
    // dispatch(actions.openEditForm(tableItem));
    setInitialData(tableItem);
    setIsPanelConfigureEditOpen(true);
    setSelectedTicketId(null);
    setSelectedTicketAnswerId(null);
  };

  const handleAnswerFormLoad = (tableItem) => {
    setInitialData(tableItem);
    setSelectedTicketId(tableItem.id);
    setSelectedTicketAnswerId(null);
  };

  const handleAnswerFormOpen = (ticket_id) => {
    setIsPanelConfigureAddAnswerOpen(true);
  }

  const handleSelectedTicket = (ticket_id) => {
    setSelectedTicketId(ticket_id);
    setSelectedTicketAnswerId(null);
    setIsPanelDocumentOpen(true);
  }

  const handleSelectedTicketAnswer = (ticket_answer_id) => {
    setSelectedTicketAnswerId(ticket_answer_id);
    setIsPanelDocumentOpen(true);
  }

  // Aquí se usa useMemo para calcular filteredData cuando cambien tickets o searchTerm
  const filteredData = useMemo(() => {
    if (!tickets) return [];
    return tickets ? tickets.filter(item =>
      item.subject.toString().toLowerCase().includes(searchTerm.toLowerCase())
    ) : [];
  }, [tableItems, tickets, searchTerm]);

  // Calcular la paginación basada en los datos filtrados
  const indexOfFirstItemFiltered = (currentPage - 1) * itemsPerPage;
  const indexOfLastItemFiltered = Math.min(indexOfFirstItemFiltered + itemsPerPage, filteredData.length);
  const currentFilteredData = filteredData.slice(indexOfFirstItemFiltered, indexOfLastItemFiltered);


  return (
    <div>
      <Row>
        <Card >
          <Card.Body>
            <Row>
              <Col>
                <input
                  type="text"
                  placeholder={t('data-lang-btn-search') + "..."}
                  value={searchTerm}
                  onChange={handleSearch}
                />
                <table className="table mt-5 table-striped table-bordered table-sm">
                  <TableHeads tableHeads={tableHeads} onSort={handleSort} />
                  <TableItems tableItems={currentFilteredData} handleEditFormOpen={handleEditFormOpen} handleAnswerFormLoad={handleAnswerFormLoad} />
                </table>
                <div className='row'>
                  <div className='col'>
                    <div className='w-25'>
                    <select className="form-select form-select-sm" value={itemsPerPage} onChange={handleItemsPerPageChange}>
                      <option value={5}>5 {t('data-lang-lbl-perpage')}</option>
                      <option value={10}>10 {t('data-lang-lbl-perpage')}</option>
                      <option value={20}>20 {t('data-lang-lbl-perpage')}</option>
                    </select>
                    </div>
                  </div>
                  <div className='col float-end'>
                    <ul className="pagination">                      
                      <li className="page-item" disabled={currentPage === 1}>
                        <a className={"page-link " + (currentPage === 1 ? 'disabled' : '') }  href="#" onClick={() => setCurrentPage(currentPage - 1)} disabled>Previous</a>
                      </li>
                      <li className="page-item">
                        <a className={"page-link " + (indexOfLastItemFiltered >= filteredData.length ? 'disabled' : '') } href="#" onClick={() => setCurrentPage(currentPage + 1)}>Next</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm delete-btn"
                  onClick={() => onOpenConfigureAddPanel()}
                >       Add
                </button>
              </Col>
            </Row>



          </Card.Body>
          <SidePanelAdd
            inputParam_IsPanelOpen={isPanelConfigureAddOpen}
            inputParam_SetterIsPanelOpen={setIsPanelConfigureAddOpen}
            item_data={initialData}
          />
          <SidePanelEdit
            inputParam_IsPanelOpen={isPanelConfigureEditOpen}
            inputParam_SetterIsPanelOpen={setIsPanelConfigureEditOpen}
            item_data={initialData}
          />
          {selectedTicketId &&
            <SidePanelAddAnswer
              inputParam_IsPanelOpen={isPanelConfigureAddAnswerOpen}
              inputParam_SetterIsPanelOpen={setIsPanelConfigureAddAnswerOpen}
              ticket_id={selectedTicketId}
            />
          }
          {selectedTicketId &&
            <SidePanelDocument
              inputParam_IsPanelOpen={isPanelDocumentOpen}
              inputParam_SetterIsPanelOpen={setIsPanelDocumentOpen}
              ticket_id={selectedTicketId}
              ticket_answer_id={selectedTicketAnswerId}
            ></SidePanelDocument>
          }
        </Card>
      </Row>

      {selectedTicketId &&
        <div>
          <Row className="mt-2">
            <Card>
              <Card.Body>
                <div>
                  <h3>Ticket Info</h3>
                  <div><ReadForm preSetData={initialData} handleAnswerFormOpen={handleAnswerFormOpen} handleSelectedTicket={handleSelectedTicket} /></div>

                </div>
              </Card.Body>
            </Card>
          </Row>
          <Row className="mt-2">
            <Card>
              <Card.Body>
                <div>
                  <h4>Ticket Answers</h4>
                  <div><TicketAnswer ticket_id={selectedTicketId} handleSelectedTicketAnswer={handleSelectedTicketAnswer} /></div>
                </div>
              </Card.Body>
            </Card>
          </Row>
        </div>
      }
    </div>
  );
};

MainSection.propTypes = {
  tableItems: PropTypes.arrayOf(PropTypes.object),
  actionsConnect: PropTypes.shape({
    addItem: PropTypes.func,
    deleteItem: PropTypes.func,
    saveItem: PropTypes.func,
    fetchItems: PropTypes.func,
  }),
};

MainSection.defaultProps = {
  tableItems: [
    {
      id: 1,
      subject: 'A new rating has been received',
      category: 'Marketing',
      assignee: 'Erwin',
      priority: 'Medium',
      status: 'Open',
      update: false,
      creation_date: '',
      answers_number: 0,
      has_docs: false
    }
  ],
};

const mapStateToProps = state => ({
  tableItems: state.tickets.tableItems,
});

const mapDispatchToProps = dispatch => ({
  actionsConnect: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainSection);
